import React, { FC } from 'react';
import cls from 'classnames';
import { DateAvatarProps } from './DateAvatar.types';
import { getClassNames, getRootClassListFromProps } from '../../../utilities/classNames';
import { dayLabels, monthLabels } from '../../../utilities/date';
import Text from '../../../components/content/text';

export const classNames = getClassNames('sds-date-avatar', ['variant-year']);

const DateAvatar: FC<DateAvatarProps> = (props) => {
	const { className, date, variant = 'month' } = props;

	const dateObj = date ? new Date(date) : new Date();

	let topLabel;
	let bottomLabel;

	switch (variant) {
		case 'year':
			topLabel = monthLabels[dateObj.getMonth()];
			bottomLabel = dateObj.getFullYear();
			break;

		case 'day':
			topLabel = dayLabels[dateObj.getDay()];
			bottomLabel = dateObj.getDate();
			break;

		case 'month':
		default:
			topLabel = monthLabels[dateObj.getMonth()];
			bottomLabel = dateObj.getDate();
			break;
	}

	return (
		<div
			className={cls(getRootClassListFromProps(classNames, props), className)}
			data-testid={props['data-testid']}
		>
			<Text textStyle="labelXSStandard">{topLabel}</Text>
			<Text
				textStyle={variant === 'year' ? 'labelSmallEmphasize' : 'labelMediumEmphasize'}
			>
				{bottomLabel}
			</Text>
		</div>
	);
};

DateAvatar.displayName = 'DateAvatar';

export default DateAvatar;
